import api from "./apiClient";

/* ===================================================== */
/* 🔧 ERROR NORMALIZER                                   */
/* ===================================================== */

function normalizeError(err, fallbackMessage) {
  return new Error(
    err?.response?.data?.message ||
      err?.message ||
      fallbackMessage
  );
}

/* ===================================================== */
/* LIST PHASES                                           */
/* GET /projects/:projectId                              */
/* ===================================================== */

export const listPhases = async (projectId) => {
  if (!projectId) {
    throw new Error("Project ID is required");
  }

  try {
    const { data } = await api.get(`/projects/${projectId}`);

    return Array.isArray(data?.phases) ? data.phases : [];
  } catch (err) {
    throw normalizeError(err, "Failed to fetch phases");
  }
};

/* ===================================================== */
/* CREATE PHASE                                          */
/* POST /projects/:projectId/phases                      */
/* ===================================================== */

export const createPhase = async (projectId, payload) => {
  if (!projectId) {
    throw new Error("Project ID is required");
  }

  if (!payload?.name?.trim()) {
    throw new Error("Phase name is required");
  }

  try {
    const { data } = await api.post(
      `/projects/${projectId}/phases`,
      {
        name: payload.name.trim(),
        description: payload.description || "",
        startDate: payload.startDate || undefined,
        endDate: payload.endDate || undefined,
        teamIds: Array.isArray(payload.teamIds)
          ? payload.teamIds
          : [],
        ownerIds: Array.isArray(payload.ownerIds)
          ? payload.ownerIds
          : [],
      }
    );

    return data;
  } catch (err) {
    throw normalizeError(err, "Failed to create phase");
  }
};

/* ===================================================== */
/* UPDATE PHASE (FUTURE READY)                           */
/* ===================================================== */

export const updatePhase = async (phaseId) => {
  throw new Error(
    "updatePhase not implemented yet. Backend endpoint missing."
  );
};

/* ===================================================== */
/* DELETE PHASE (FUTURE READY)                           */
/* ===================================================== */
export const deletePhase = async (projectId, phaseId) => {
  if (!projectId || !phaseId) {
    throw new Error("Project ID and Phase ID are required");
  }

  try {
    await api.delete(`/projects/${projectId}/phases/${phaseId}`);
    return true;
  } catch (err) {
    throw normalizeError(err, "Failed to delete phase");
  }
};
/* ===================================================== */
/* EXPORT                                                */
/* ===================================================== */

const phaseService = {
  listPhases,
  createPhase,
  updatePhase,
  deletePhase,
};

export default phaseService;